import React from 'react';

import { Badge, Container, CustomTooltip, Divider } from '../../styles';

export interface KeysToolTipProps {
  value: string;
  color: string;
  keysValue?: { date: string; info: { [key: string]: string[] } };
}

export const KeysTooltip: React.FC<KeysToolTipProps> = ({
  value,
  color,
  keysValue,
}: KeysToolTipProps) => {
  const haveKeysValue = keysValue
    ? Object.keys(keysValue?.info).length > 0
    : false;
  return (
    <Container color={color}>
      {value && value !== '-' && (
        <CustomTooltip
          position={['right top', 'right bottom', 'left bottom', 'left top']}
          keepTooltipInside={false}
          on={['hover']}
          trigger={<Badge value={value} />}
        >
          <div style={{ width: '100%', height: '100%', padding: '12px' }}>
            {haveKeysValue && keysValue ? (
              Object.keys(keysValue.info).map((dataKey, index) => {
                return (
                  <div
                    key={`title-key-${index as number}`}
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <p>{dataKey}</p>
                    {keysValue.info[dataKey].map(
                      (element: string, index: number) => {
                        return (
                          <div
                            key={`title-data-key-${index as number}`}
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '4px',
                            }}
                          >
                            <p style={{ color: '#6c757d' }}>{element}</p>
                          </div>
                        );
                      },
                    )}
                    {Object.keys(keysValue.info).length !== index + 1 && (
                      <Divider />
                    )}
                  </div>
                );
              })
            ) : (
              <span>Sem dados</span>
            )}
          </div>
        </CustomTooltip>
      )}
    </Container>
  );
};
